module.exports = __webpack_public_path__ + "static/media/logo.abc68a9b.png";